/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../magnolia/lib/MagnoliaPropertyHelper';

export default interface Column {
  fields: any;
  horizontalPosition: string;
  verticalPosition: string;
  margin: string;
  marginY ? : string;
  marginMobile: string;
  marginMobileY ? : string;
  metadata ? : any;
}

export const Props = {
  fields: Object,
  horizontalPosition: String,
  verticalPosition: String,
  margin: String,
  marginY: String,
  marginMobile: String,
  marginMobileY: String,
  metadata: Object,
}

export const WrapperProps = {
  fields: Object,
  horizontalPosition: String,
  verticalPosition: String,
  margin: String,
  marginY: String,
  marginMobile: String,
  marginMobileY: String,
  metadata: Object,
}

export class ColumnBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class ColumnInstance implements Column {
      horizontalPosition: string;
      verticalPosition: string;
      margin: string;
      marginY ? : string;
      marginMobile: string;
      marginMobileY ? : string;
      fields: any;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

      }
    }
    return new ColumnInstance(props);
  }
}
